import React from 'react';
import './VCNRContactSection.css';
import waveImage from '../../Assets/leadership/astronaut.png'; 
import iconOffice from '../../Assets/contact/icon-office.png';
import iconPhone from '../../Assets/contact/icon-phone.png';
import iconMail from '../../Assets/contact/icon-mail.png';
import arrowImage from '../../Assets/contact/contact-us-arrow.png';

const ContactUsSection = () => {
  return (
    <div className="vcnr-contactus-full-wrapper">
      {/* Top Decorative Wave Image */}
      {/* <div className="vcnr-wave-image-wrapper">
        <img src={waveImage} alt="Wave Background" className="vcnr-wave-image" />
      </div> */}

      {/* Contact Cards Section */}
      <div className="vcnr-contactus-section">
        <div className="vcnr-contactus-container">
          <div className="vcnr-arrow-wrapper">
            <img src={arrowImage} alt="Arrow" className="vcnr-left-arrow" />
          </div>

          <div className="vcnr-contactus-wrapper">
            <div className="vcnr-contactus-card vcnr-contactus-card-purple">
              <img src={iconOffice} alt="Office" className="vcnr-contactus-icon" />
              <h4 className="vcnr-contactus-title">
                Corporate Office<br /><span>VCNR Group HQ</span>
              </h4>
              <p className="vcnr-contactus-description">
                135, VCNR Towers, Vinayaka Nagar,
                BH Road, Binnamangala Nursery,
                Nelamangala Town, Karnataka 562123
              </p>
            </div>

            <div className="vcnr-contactus-card vcnr-contactus-card-white">
              <img src={iconPhone} alt="Phone" className="vcnr-contactus-icon" />
              <h4 className="vcnr-contactus-title">PHONE NUMBER</h4>
              <p className="vcnr-contactus-description">
                080 2351 1531<br />+91 63649 14088
              </p>
            </div>

            <div className="vcnr-contactus-card vcnr-contactus-card-purple">
              <img src={iconMail} alt="Email" className="vcnr-contactus-icon" />
              <h4 className="vcnr-contactus-title">EMAIL ADDRESS</h4>
              <p className="vcnr-contactus-description">
                info@vcnrworld.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsSection;
